import { jsonApi } from '../http-request';

export const NAME = {
  SET_SELECTED_ID: 'NAME_SET_SELECTED_ID',
};

export const actions = jsonApi.createUpdResourceFacade('names');

actions.setSelectedId = id => ({
  type: NAME.SET_SELECTED_ID,
  payload: id,
});
